module.exports = __webpack_public_path__ + "img/sb.9f822fef.svg";